const HouseplanfaqData = [
      {
        question: 'What is included in the house plan package?',
      answer:
        'Our house plan packages typically include detailed floor plans, elevations, sections, construction drawings, material lists, and specifications. Depending on the package, 3D renderings and virtual walkthroughs may also be included.',
      },
      {
        question: 'Can I customize the house plans?',
        answer:
          'Yes, we offer customization options to tailor the plans to your specific needs and preferences. Contact us to discuss your requirements and get a quote for customization.',
      },
      {
        question: 'What is the process for obtaining a building permit with your plans?',
        answer:
          'You will need to submit your house plans along with other required documents to your local building department. We recommend consulting with them for specific requirements and procedures.',
      },
      {
        question: 'How long does it take to receive the house plans after purchase?',
        answer:
          'Typically, you will receive the digital house plans via email within 1-2 business days after purchase. Physical copies may take an additional 3-5 business days for shipping.',
      },
      {
        question: 'Do your house plans comply with local building codes?',
        answer:
          'Our plans are designed to meet general building standards. However, local building codes vary, so we recommend having your plans reviewed by a local building professional or your building department to ensure compliance.',
      },
    ];

export default HouseplanfaqData;